const config = {
  default: 'en_GB',
  map: {
    en: 'en_GB',
    de: 'de_DE',
    fr: 'fr_FR',
    es: 'es_ES',
    zh_CN: 'zh_CN',
    ja: 'ja_JP',
    pt_BR: 'pt_BR',
    it_IT: 'it_IT',
    ko: 'ko_KR',
  },
}

export default config
